module.exports = __webpack_public_path__ + "img/excel.51d62f41.svg";